import { QueryClient } from "@tanstack/react-query";

/** 既定のTanStack Queryクライアント */
export const TANSTACK_QUERY_CLIENT = new QueryClient();
